import { render, staticRenderFns } from "./LimitControl.vue?vue&type=template&id=354fa5b5&scoped=true"
import script from "./LimitControl.vue?vue&type=script&lang=js"
export * from "./LimitControl.vue?vue&type=script&lang=js"
import style0 from "./LimitControl.vue?vue&type=style&index=0&id=354fa5b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fa5b5",
  null
  
)

export default component.exports